import React from "react";

export default function Boton (props) {
    const nada = ()=>{}
    return (
        <button                 
        className="BotonAvanzar"
        type={props.tipo || "button"}
        onClick={props.onClick || nada}>
            {props.texto}
        </button>
    )
}